export class UserRoleVM {
    constructor({userId,isActive,rolename}) {
      this.userId = userId;
      this.isActive = isActive;
      this.rolename = rolename;
    }
  }
  